import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { H2 } from './typography'
import Tabs from './tabs'

function ComparationSection({
  setLink, tabActive, data, noTabs,
}) {
  const section = useRef(null)

  useEffect(() => {
    Promise.resolve(
      typeof window.IntersectionObserver !== 'undefined'
        ? window.IntersectionObserver
        : import('intersection-observer'),
    ).then(() => {
      const observeOptions = {
        threshold: 0.3,
      }
      const callback = (entries) => {
        if (entries[0].isIntersecting) {
          setLink(entries[0].target.id)
        }
      }
      const observer = new window.IntersectionObserver(callback, observeOptions)
      observer.observe(section.current, observeOptions)
    })
  }, [])

  return (
    <section key={data.title} id={data.id} ref={section}>
      <H2>{data.title}</H2>
      {data.content}
      {!noTabs && <Tabs options={data.tabs} tabActive={tabActive} />}
    </section>
  )
}

ComparationSection.defaultProps = {
  noTabs: false,
}

ComparationSection.propTypes = {
  setLink: PropTypes.func.isRequired,
  tabActive: PropTypes.string.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
    content: PropTypes.node,
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        component: PropTypes.node,
      }),
    ).isRequired,
  }).isRequired,
  noTabs: PropTypes.bool,
}

export default ComparationSection
